import { defineMessages } from 'react-intl';

const scope = 'buttonLabel';

export default defineMessages({
  chatWithUs: {
    id: `${scope}.chat_with_us`,
    defaultMessage: 'Chat with an agent',
  },
  chatUnavailable: {
    id: `${scope}.chat_unavialable`,
    defaultMessage: 'Agents are offline',
  },
  endConversation: {
    id: `${scope}.end_conversation`,
    defaultMessage: 'End agent chat',
  },
  startingConversation: {
    id: `${scope}.starting_conversation`,
    defaultMessage: 'Starting conversation',
  },
  endingConversation: {
    id: `${scope}.ending_conversation`,
    defaultMessage: 'Ending conversation',
  },
});
